<div
  *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')&& (global.agencyCode=='SUPERADMIN')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000') || (global.agencyCode!='SUPERADMIN')">
  <div class="row mb-2" *ngIf="!employeeTemplateBO.templateToOnboard && !ClientTemplateBO.templateToOnboard">
    <div class="col  pl-0">
      <div class="row">
        <div class="col-12">
          <h4 class="mb-0 font-header-1 mb-2"> Agreement Templates </h4>
        </div>
      </div>
      <div class="card border-0 box-shadow mt-2">
        <div class="card-body">
          <div class="row d-flex align-items-center">

            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="col-11 d-inline-flex">
                <input type="text" placeholder="Template Name" (keyup.enter)="getOnboardTemplateList()"
                  [(ngModel)]="gridTemplateBO.value" style="width:65%"
                  [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'||global.globalAgencyId==null||global.globalAgencyId==''"
                  class="form-control ">
                <i class="bi bi-search  mt-1 fs-5 iconSearch" (click)="getOnboardTemplateList()"
                  style="margin-left:-20px"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-lg-end ">
              <button class="btn btn-sm ms-5" data-bs-toggle="modal" data-bs-target="#templateModal"
                (click)="clearName()" *ngIf="fp.clienttemplatecreate && PrivatePaySelectedTab == 'Client'">Create
                Template
              </button>
              <button class="btn btn-sm ms-5" data-bs-toggle="modal" data-bs-target="#templateModal"
                (click)="clearName()" *ngIf="PrivatePaySelectedTab == 'Employee' && fp.employeetemplatecreate">Create
                Template
              </button>
              <button class="btn btn-sm me-1 ms-5" (click)="refresh()">Refresh </button>

            </div>
          </div>
          <div class="row mt-3 pt-2">

            <div class="col-lg-12">
              <nav>
                <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                  <a class="nav-item nav-link active" id="nav-unlocked-tab" data-bs-toggle="tab" href="#nav-unlocked"
                    role="tab" aria-controls="nav-unlocked" aria-selected="true" (click)="tabchange('Client')"
                    [ngClass]="{
                        'mytab-inactive':
                          PrivatePaySelectedTab != 'Client',
                        active: PrivatePaySelectedTab == 'Client'
                      }">Participant Agreement
                  </a>
                  <a class="nav-item nav-link" id="nav-active-tab" data-bs-toggle="tab" href="#nav-active" role="tab"
                    aria-controls="nav-active-tab" aria-selected="false" (click)="tabchange('Employee')" [ngClass]="{
                        'mytab-inactive': PrivatePaySelectedTab != 'Employee',
                        active: PrivatePaySelectedTab == 'Employee'
                      }">Employee Agreement</a>

                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                  aria-labelledby="nav-unlocked-tab" [ngClass]="{
                      active: PrivatePaySelectedTab == 'Client',
                      show: PrivatePaySelectedTab == 'Client'
                    }">
                  <!-- UnLocked  ejs-grid -->
                  <div class="row mb-2 mt-1">

                    <div class="col-lg-12 pl-0">
                      <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowPaging]="true"
                        [allowMultiSorting]='true' [filterSettings]='filterOption' [allowSorting]="true"
                        [pageSettings]="pageSettings" (dataStateChange)='dataChangeAgreement($event)'
                        (actionBegin)="onActionAgreement($event)">


                        <e-columns>
                          <e-column headerText="Actions" textAlign="center" minWidth=40>
                            <ng-template #template let-data>
                              <button (click)="edit(data)" class="btn btn-sm"
                                *ngIf="fp.clienttemplateupdate || fp.employeetemplateupdate"><i
                                  class="fa fa-edit"></i></button> &nbsp;
                            </ng-template>
                          </e-column>
                          <e-column field='templateName' textAlign='left' type='string' headerText='Template Name'
                            minWidth=50>
                            <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template></e-column>

                        </e-columns>
                      </ejs-grid>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="nav-active" role="tabpanel" aria-labelledby="nav-active-tab" [ngClass]="{
                      active: PrivatePaySelectedTab == 'Employee',
                      show: PrivatePaySelectedTab == 'Employee'
                    }">
                  <!-- Locked  ejs-grid  -->
                  <div class="row p-2" class="e-resizable">
                    <div class="col-lg-12" width="200%">
                      <ejs-grid #gridEmp [dataSource]='data | async' [allowResizing]='true' [allowPaging]="true"
                        [allowMultiSorting]='true' [filterSettings]='filterOption' [allowSorting]="true"
                        [pageSettings]="pageSettings" (dataStateChange)='dataChangeAgreementEmp($event)'
                        (actionBegin)="onActionAgreementEmp($event)">
                        <e-columns>
                          <e-column headerText="Actions" textAlign="center" minWidth=40>
                            <ng-template #template let-data>
                              <button (click)="edit(data)" class="btn btn-sm"><i class="fa fa-edit"></i></button> &nbsp;
                            </ng-template>
                          </e-column>
                          <e-column field='templateName' textAlign='left' type='string' headerText='Template Name'
                            minWidth=50> <ng-template #filterTemplate let-data>
                              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template></e-column>
                        </e-columns>
                      </ejs-grid>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-clienttemplate (dataEmitTemplate)="dataEmitFromOnboard($event)" *ngIf="ClientTemplateBO.templateToOnboard"
  [ClientTemplateBO]="ClientTemplateBO"></app-clienttemplate>

<app-employee-agreement-template [employeeTemplate]="employeeTemplateBO" *ngIf="employeeTemplateBO.templateToOnboard"
  (dataEmitemployeeTemplate)="dataEmitAgreementEmployee($event)"></app-employee-agreement-template>

<span id="templateNameModal" data-bs-toggle="modal" data-bs-target="#templateModal"></span>
<div class="modal fade modalbackgrod" id="templateModal" tabindex="-1" aria-labelledby="templateModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog mt-5 pt-5" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="templateModalLabel"> Create Template</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">

        <div class="row mt-3">
          <div class="col-lg-4">
            <label>Template Name<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
          </div>
          <div class="col-lg-6">
            <input type="text" class="form-control" [(ngModel)]="ClientTemplateBO.templatename"
              *ngIf="PrivatePaySelectedTab == 'Client'">
            <input type="text" class="form-control" [(ngModel)]="employeeTemplateBO.templateName"
              *ngIf="PrivatePaySelectedTab != 'Client'">

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="create()" *ngIf="PrivatePaySelectedTab == 'Client'"
          [disabled]="ClientTemplateBO.templatename==null|| ClientTemplateBO.templatename=='' || ClientTemplateBO.templatename==undefined">Create</button>
        <button type="button" class="btn btn-sm" (click)="create()" *ngIf="PrivatePaySelectedTab != 'Client'"
          [disabled]="employeeTemplateBO.templateName==null || employeeTemplateBO.templateName=='' || employeeTemplateBO.templateName==undefined">Create</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>